import { render, staticRenderFns } from "./ItineraryCardFooter.vue?vue&type=template&id=5948e8cc&scoped=true&"
import script from "./ItineraryCardFooter.vue?vue&type=script&lang=js&"
export * from "./ItineraryCardFooter.vue?vue&type=script&lang=js&"
import style0 from "./ItineraryCardFooter.vue?vue&type=style&index=0&id=5948e8cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5948e8cc",
  null
  
)

export default component.exports